import { useHistory } from 'react-router-dom';
import logo from '../../assets/images/logo-invert.png';
import './LogoutPage.scss';

export const LogoutPage = () => {
    const history = useHistory();

    const handleSignIn = () => {
        history.push('/');
    };

    return (
        <main className="logout-main" role="main" aria-labelledby="logout-title">
            <div className="logout-card">
                <div className="logout-brand">
                    <img src={logo} alt="Panviva" className="logout-brand-logo" />
                </div>
                <h1 id="logout-title" className="logout-title">You're signed out</h1>
                <button
                    type="button"
                    className="logout-signin-button"
                    onClick={handleSignIn}
                    aria-label="Sign in"
                >
                    Sign in
                </button>
                <p className="logout-message">
                    Your Panviva Pulse session has ended.
                </p>
                <p className="logout-submessage">Sign in to continue working with your knowledge and tools.</p>
            </div>
        </main>
    );
};

export default LogoutPage;
